export const appSettings = {
  serverBaseUrl: process.env.REACT_APP_SERVER_BASE_URL,
};
